export enum CouponTypeEnum {
  COUPON_00A = 'COUPON_00A',
  COUPON_00B = 'COUPON_00B',
}

export type CouponType = keyof typeof CouponTypeEnum;
